import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const computerOptions = [
  "Ordinateur",
  "Imprimante",
  "Ecran",
  "Serveur",
  "Onduleur",
  "Caisse informatique",
  "Destructeur de documents"
];

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

export default function MaterielInfoModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState({
    category: 'materiel_informatique',
    name: '',
    existing_quantity: 1,
    verified_quantity: 1,
    protection_type: 'PC',
    continuity_result: 'Bon',
    isolement: '',
    result: 'conforme'
  });

  useEffect(() => {
    if (equipment) {
      setFormData(equipment);
    }
  }, [equipment]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.continuity_result) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }
    onSave({
      type: 'materiel_info',
      ...formData
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">💻 Matériel informatique</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Désignation du matériel informatique <span className="equipment-required">*</span>
              </label>
              <input
                type="text"
                list="computer-options"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="equipment-form-input"
                placeholder="Sélectionnez ou saisissez une désignation"
                required
              />
              <datalist id="computer-options">
                {computerOptions.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({...formData, existing_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité vérifiée</label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({...formData, verified_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <input
                type="text"
                value={formData.protection_type}
                onChange={(e) => setFormData({...formData, protection_type: e.target.value})}
                className="equipment-form-input"
              />
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Continuité PE <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="SO-PI">SO-PI</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-info"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({...formData, isolement: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-info">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-form-buttons">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              ← Retour
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}